import { combineReducers } from 'redux'
import { createForms } from 'react-redux-form/immutable'
import { routerReducer as routing } from 'react-router-redux'

import app from 'containers/App/reducer'
import { passwordState } from 'containers/Account/reducer'
import notification from 'components/Notification/reducer'
import auth, { loginState } from 'containers/Auth/reducer'
import { changeSemState } from 'containers/Admin/reducer'
import curriculum, { curriculumState, curriculumSubjectState } from 'containers/Manage/Curriculums/reducer'
import paymentscheme, { paymentschemeState, psFeeState } from 'containers/Manage/PaymentSchemes/reducer'
import semcampcollege, { semcampcollegeState } from 'containers/Setup/Colleges/reducer'
import semcampcourse, { semcampcourseState } from 'containers/Setup/Courses/reducer'
import semcampscholarship, { semcampscholarshipState } from 'containers/Setup/Scholarships/reducer'
import offering, { offeringState } from 'containers/Setup/Offerings/reducer'
import subject from 'containers/Subjects/reducer'
import employee from 'containers/Employees/reducer'

export default combineReducers({
  // main reducers
  app,
  auth,
  notification,
  curriculum,
  paymentscheme,
  semcampcollege,
  semcampcourse,
  semcampscholarship,
  offering,
  subject,
  employee,

  // react-redux-form
  ...createForms({
    loginState,
    passwordState,
    changeSemState,
    curriculumState,
    curriculumSubjectState,
    paymentschemeState,
    psFeeState,
    semcampcollegeState,
    semcampcourseState,
    semcampscholarshipState,
    offeringState,
  }),

  // other
  routing,
})

/* import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'

import app from 'containers/App/reducer'
import { passwordModel, passwordForm } from 'containers/Account/reducer'
import notification from 'components/Notification/reducer'
import auth, { loginModel, loginForm } from 'containers/Auth/reducer'
import { changeSemModel, changeSemForm } from 'containers/Admin/reducer'
import curriculum, { curriculumModel, curriculumForm, curSubjectModel, curSubjectForm } from 'containers/Manage/Curriculums/reducer'
import paymentscheme, { paymentschemeModel, paymentschemeForm, paymentschemefeeModel, paymentschemefeeForm } from 'containers/Manage/PaymentSchemes/reducer'
import semcampcollege, { semcampcollegeModel, semcampcollegeForm } from 'containers/Setup/Colleges/reducer'

export default combineReducers({
// main reducers
app,
auth,
notification,
curriculum,
paymentscheme,
semcampcollege,

// model reducers
loginModel,
passwordModel,
changeSemModel,
curriculumModel,
curSubjectModel,
paymentschemeModel,
paymentschemefeeModel,
semcampcollegeModel,

// form reducers
loginForm,
passwordForm,
changeSemForm,
curriculumForm,
curSubjectForm,
paymentschemeForm,
paymentschemefeeForm,
semcampcollegeForm,

// other
routing,
})
*/



// WEBPACK FOOTER //
// ./src/reducers.js